import * as QueryString from 'query-string';
import asArray from './asArray';

export default function getPackagesIdsFromQSParams(props) {
    const { location: { search } } = props;
    const params = QueryString.parse(search);
    const packages = asArray(params.packages);
    return packages;
}